<template>
  <footer class="custom-footer">
    <div class="container">
      <p>
        © 2025 Leonar2 — Todos los derechos reservados |
        <a href="#">Política de privacidad</a> |
        <a href="#">Términos de uso</a>
      </p>
    </div>
  </footer>
</template>
<script></script>
<style>
/* --- Footer personalizado --- */
.custom-footer {
  background-color: #0d1b2a;
  color: #eee;
  text-align: center;
  padding: 20px 0;
  font-size: 14px;
}

.custom-footer a {
  color: #00bcd4;
  text-decoration: none;
  margin: 0 5px;
}

.custom-footer a:hover {
  text-decoration: underline;
}
</style>
